







import TreatmentRequestListMobile from "../mobile/treatment-requests/TreatmentRequestListMobile.vue";
import TreatmentRequestList from "./TreatmentRequestList.vue";
import ResponsiveLayout from "../../mixin/ResponsiveLayout.vue";

export default {
  components: {
    ResponsiveLayout,
    TreatmentRequestListMobile,
    TreatmentRequestList,
  },
  data() {
    return {
      TreatmentRequestList,
      TreatmentRequestListMobile,
    };
  },
};
